import { render, staticRenderFns } from "./UserDetailGroup.vue?vue&type=template&id=459d5358&scoped=true&"
import script from "./UserDetailGroup.vue?vue&type=script&lang=ts&"
export * from "./UserDetailGroup.vue?vue&type=script&lang=ts&"
import style0 from "./UserDetailGroup.vue?vue&type=style&index=0&id=459d5358&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459d5358",
  null
  
)

export default component.exports